import {clsx} from "clsx";
import {useNavigate} from "react-router";

import {headerHeight} from "../../constants";

export interface LogoProps {
	sidebarCollapsed: boolean
	className?: string
}

/**
 * @zh 高度 48px
 * @en The height is 48px
 */
export function Logo({className}: LogoProps) {
	const navigate = useNavigate();

	return (
		<div
			style={{height: headerHeight, width: "150px", marginLeft: "10px"}}
			className={clsx("flex items-center justify-center gap-2 cursor-pointer", className)}
			onClick={() => navigate(import.meta.env.VITE_BASE_HOME_PATH)}
		>
		</div>
	);
}
